import type { FaireProductEntity } from "../../entity_types/product";

export const p_uac8mru2pn: FaireProductEntity = {
  token: "p_uac8mru2pn",
  type: "product",
  name: "Navy Bow Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f7d6ece56559c1399e1e88302ef947c548e77a975566fa9a7d83c487b0f67898.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b96ac9ccbe8ca94d64ec96520a5d4e2c4773961f3ba3381a31d5e80fc156364.jpeg",
    "https://cdn.faire.com/fastly/f4810c39a0a2ffdea90f65306214ba9a6f72e7a525bb07ea0b67069d9bdd9ab4.jpeg",
    "https://cdn.faire.com/fastly/18ed571b37b91c719386f89823cd48f572fb6700c74b489f5fc709eab9b50608.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:36.530Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
